if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.freeSamples = document.querySelector('.general-samples-swiper.swiper');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitButton.dataset?.stickyAtb === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // remove ordergroove selling_plan from formData so non subscription products can add to cart cql-693
        const productInfoEl = document.querySelector('product-info');
        const hasSellingPlan = productInfoEl?.dataset.sellingPlanExists === 'true';
        if (!hasSellingPlan) {
          formData.delete("selling_plan");
        }

        const bundleKey = `bundle_${new Date().getTime()}`; // Example unique key using timestamp
        const productInfoWrapper = this.closest('.product__info-wrapper') || document;
        const productInfoScope = this.closest('product-info') || productInfoWrapper || document;
        const isBundle = productInfoWrapper.querySelector('.bundle-product') !== null;
        const parentVariantId = productInfoWrapper.querySelector('.product-variant-id');
        let bundlePrice = productInfoWrapper.querySelector('input[name="bundle_price"]');
        let bundleSku = productInfoWrapper.querySelector('input[name="bundle_sku"]');

        const bundleProductID = productInfoScope.querySelector(`input[name="bundle_product_id"]`)?.value; // 'Bundle Product ID';
        const bundleName = productInfoScope.querySelector(`input[name="bundle_product_name"]`)?.value; //'Bundle Name';
        const bundleProductHandles = productInfoScope.querySelector(`input[name="bundle_product_handles"]`)?.value; //'All the bundle handles';
        const bundleImage = productInfoWrapper.querySelector(`input[name="bundle_image"]`)?.value; // 'Bundle Image URL';
        const bundleShade = productInfoWrapper.querySelector(`input[name="bundle_shade"]`)?.value;
        const bundleSize = productInfoWrapper.querySelector(`input[name="bundle_size"]`)?.value;
        const promoFlags = window.getPromoLineItemProperties(
          ['.product-section product-info[data-view-context="PDP"]', 'product-info[data-view-context="Quickview"]'],
          { mode: 'flags' }
        );

        const isVtoContext = !!this.closest('vto-modal');
        const customSource = productInfoScope?.dataset?.source;

        if (customSource) {
          formData.append('properties[_source]', customSource);
          if (customSource === 'tarte_gwp') {
            formData.append('properties[_tarte_promotion]', 'free_gwp');
            formData.append('properties[_tarte_gwp_type]', 'user_selected');

            const selectableCount = parseInt(productInfoScope?.dataset?.selectableCount || '1', 10);
            if (typeof window.removeUserSelectedGwpItems === 'function') {
              const gwpCartRes = await fetch('/cart.js');
              const gwpCart = await gwpCartRes.json();
              const currentGwpCount = (gwpCart.items || []).filter(
                item => item.properties?._tarte_gwp_type === 'user_selected'
              ).length;

              if (currentGwpCount >= selectableCount) {
                const gwpProductIds = productInfoScope?.dataset?.gwpProductIds?.split(',').filter(Boolean) || [];
                await window.removeUserSelectedGwpItems(gwpCart, gwpProductIds);
              }
            }
          }
        } else if (isVtoContext) {
          formData.append('properties[_source]', 'vto');
        } else {
          formData.append('properties[_source]', 'pdp');
        }

        const bundleHandle = productInfoWrapper.querySelector(`input[name="bundle_handle"]`)?.value; // 'Bundle Handle';

        const bundleComponents = typeof window.getSelectedBundleComponents === 'function'
          ? window.getSelectedBundleComponents(productInfoWrapper)
          : [];

        const showWaitlistModal = () => {
          const waitlistModal = document.getElementById('Waitlist-Modal-product');
          waitlistModal?.show();
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
        };

        let bundleData = {
          data: {
            items: isBundle && parentVariantId?.value && bundleComponents.length && typeof window.buildBundleLineItem === 'function'
              ? [window.buildBundleLineItem({
                parentVariantId: parentVariantId.value,
                components: bundleComponents,
                properties: {
                  '_bundle_key': bundleKey,
                  '_parent_id': parentVariantId.value,
                  '_bundle_sku': bundleSku.value,
                  '_bundle_name': bundleName,
                  '_bundle_product_handles' : bundleProductHandles,
                  '_bundle_image': bundleImage,
                  '_bundle_product_id': bundleProductID,
                  '_bundle_handle': bundleHandle,
                  '_bundle_shade': bundleShade,
                  '_bundle_size': bundleSize,
                  ...promoFlags
                }
              })]
              : [],
            sections: this.cart ? this.cart.getSectionsToRender().map(section => section.id) : [],
          },
        };

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (isBundle && !bundleData.data.items.length) {
          this.handleErrorMessage('Something went wrong. Please try reloading and adding to cart again.');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          return;
        }

        if (isBundle && typeof window.updateDuplicateBundleSwatchAvailability === 'function') {
          await window.updateDuplicateBundleSwatchAvailability(productInfoScope, { forceFetch: true });
        }

        if (isBundle && window.hasUnavailableSelectedBundleInput?.(productInfoScope)) {
          showWaitlistModal();
          return;
        }

        isBundle ? config.body = bundleData.data : config.body = formData;

        // Check if the button includes "Join the Waitlist"
        if (this.submitButtonText.textContent.toUpperCase().includes(window.variantStrings.joinTheWaitlist.toUpperCase())) {
          showWaitlistModal();
          return;
        }
        // lets try adding the sections to the config.body
        config.body.sections = ['cart-drawer', 'cart-icon-bubble'];

        const productContainer = document.querySelector('.main-product-data');
        const variantId = parentVariantId?.value;
        const variantIdNumber = Number(variantId);
        const productId = Number(bundleProductID);

        const { maxQuantityNumber, variantShade, productTitle } =
          getProductAndVariantMetafieldsData(productContainer, variantIdNumber) || {};

        const cart = typeof window.getCurrentTarteCartData === 'function'
          ? await window.getCurrentTarteCartData()
          : await fetch('/cart.js').then(res => res.json());

        let currentQtyInCart = 0;

        if (isBundle) {
          currentQtyInCart = (cart?.items || []).reduce((sum, item) => {
            return item.product_id === productId ? sum + item.quantity : sum;
          }, 0);
        } else {
          currentQtyInCart = await window.getVariantQuantityInCart(variantId, cart);
        }

        if (currentQtyInCart >= maxQuantityNumber) {
          const name = `${productTitle} - ${variantShade}` || 'this product';
          window.showQuantityLimitModal(name, maxQuantityNumber);
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          return;
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: isBundle ? {
            'Content-Type': 'application/json'
          } : config.headers,
          body: isBundle ? JSON.stringify(config.body) : config.body
        })
          .then((response) => 
              response.json()
          )
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const publishCartUpdate = () => {
              const cartUpdateEvent = {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              };

              if (typeof publishDeferred === 'function') {
                publishDeferred(PUB_SUB_EVENTS.cartUpdate, cartUpdateEvent);
              } else {
                window.setTimeout(() => publish(PUB_SUB_EVENTS.cartUpdate, cartUpdateEvent), 0);
              }
            };

            this.error = false;
            const renderCartResponse = () => {
              if (response.sections) {
                this.cart.renderContents(response);
                if (this.freeSamples) {
                  window.initFreeSamplesSwiper(this.freeSamples);
                }
                publishCartUpdate();
                return Promise.resolve();
              }

              // Fallback: fetch rendered cart sections.
              return this.fetchCartSections(['cart-drawer', 'cart-icon-bubble'])
                .then(sections => {
                  // add the sections to the response
                  response.sections = sections;
                  this.cart.renderContents(response);
                  if (this.freeSamples) {
                    window.initFreeSamplesSwiper(this.freeSamples);
                  }
                  publishCartUpdate();
                });
            };

            const quickAddModal = this.closest('#Quickshop-Modal') || this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    renderCartResponse();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              return renderCartResponse();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
           this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      fetchCartSections(sections = ['cart-drawer', 'cart-icon-bubble']) {
        const root = window.Shopify.routes?.root || '';
        const localePrefix = root.endsWith('/') ? root.slice(0, -1) : root;
        const params = new URLSearchParams();
        params.append('sections', sections.join(','));
        return fetch(`${localePrefix}/?${params.toString()}`, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(res => {
          if (!res.ok) throw new Error(`Sections request failed: ${res.status}`);
          return res.json();
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!text) {
            text = window.variantStrings.addToCart;
        }
        if (text === window.variantStrings.joinTheWaitlist) {
            this.submitButton.removeAttribute('disabled');
        } else if (text === window.variantStrings.soldOut) {
            this.submitButton.setAttribute('disabled', 'disabled');
        } else {
            this.submitButton.toggleAttribute('disabled', disable);
        }
        this.submitButtonText.innerHTML = text;
      }

      // Shows/hides Buy Now from real variant state; no-op unless the form has the attribute (buy-buttons.liquid).
      setExpressCheckoutHidden(hidden) {
        if (!this.submitButton.hasAttribute('data-express-checkout-hidden')) return;
        this.submitButton.setAttribute('data-express-checkout-hidden', String(Boolean(hidden)));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
